const handleComplete = (xhrResponse) => {
  if (!xhrResponse.ok) throw xhrResponse;
  return xhrResponse?.json();
};

export default handleComplete;
